// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".saleSummary[data-v-892939e4] {\n  display: flex;\n  flex-wrap: wrap;\n  padding-top: 8px;\n}\n.saleSummary .item[data-v-892939e4] {\n  width: 282px;\n  margin-right: 24px;\n  margin-bottom: 21px;\n}", ""]);
// Exports
module.exports = exports;
